import styles from '~/styles/molecules/header/header_organaization.module.scss'
import { ChildProps } from '~/common/define/props'

const OrganizationHeaderItems = ({children}: ChildProps) => {
  return (
    <div className={styles.headerOrganization__items}>
      {children}
    </div>
  )
}

export default OrganizationHeaderItems